import React from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import InputField from 'components/InputField';
import validations from 'validations';

import './EmailField.styles.scss';

type EmailFieldProps = {
  className?: string;
  name?: string;
  label?: string;
  disabled?: boolean;
  readOnly?: boolean;
  formatOnBlur?: boolean;
  isVerified?: boolean;
  required?: boolean;
  showInitialError?: boolean;
  format?: (value: string) => void;
  onChangeHandle?: (value: string) => void;
  customOnBlur?: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
};

const EmailField: React.FC<EmailFieldProps> = (props) => {
  const {
    className,
    label,
    name = 'email',
    disabled = false,
    readOnly = false,
    formatOnBlur = false,
    isVerified = false,
    required = false,
    showInitialError = false,
    format,
    onChangeHandle,
    customOnBlur,
  } = props;

  const classes = classNames('email-field', className);

  const { t } = useTranslation();

  return (
    <Field
      name={name}
      component={InputField}
      className={classes}
      type="email"
      label={label || t('email')}
      disabled={disabled}
      readOnly={readOnly}
      formatOnBlur={formatOnBlur}
      isVerified={isVerified}
      required={required}
      showInitialError={showInitialError}
      validate={validations.composeValidators(
        required ? validations.required() : null,
        validations.email(),
      )}
      format={format}
      onChangeHandle={onChangeHandle}
      customOnBlur={customOnBlur}
    />
  );
};

export default EmailField;
